import React, { useState, useEffect } from 'react';
import { Translate } from '../../language';
import { connect } from 'react-redux'
import * as Yup from "yup";
import { getUserInfo } from '../../actions/userActions'
import { sendNewPassword } from '../../actions/recoverActions'
import inMemoryJWT from '../../auth/inMemoryJwt'
import ResetPasswordView from '../../containers/Profile/Password/ResetPasswordView';
import { useFormik } from 'formik';

const ResetPassword = ({ history, userInfo, getUserInfo, sendNewPassword, errorType }) => {
    const validationSchema = Yup.object().shape({
        password: Yup.string().required("Es requerido"),
        confirmPassword: Yup.string().required("Es requerido"),
    });
    const formik = useFormik({
        initialValues: {
            password: '',
            newPassword: '',
            confirmPassword: '',
        },
        validationSchema:validationSchema,
        onSubmit: (values) => {

            sendNewPassword(values,history)
        },
        // handleChange: (event)=>{
        //   console.log()
        // }
    });
    return <ResetPasswordView firstName={userInfo.name} secondName={userInfo.lastname} formik={formik} history={history}/>
    
    
}

const mapStateToProps = (state) => {
    return {
        userInfo: state.userInfo.userInfo,
        errorType: state.recover.errorType
    }
}


export default connect(mapStateToProps, { getUserInfo, sendNewPassword })(ResetPassword)
